import { useCallDetailsStore } from "@expert/sales-tools";
import { Partner } from "@expert/shared-types";

import type { IVRInfo, VoiceTask } from "@/sdk";

import { isVoiceTask, useMostRecentTask, usePartner } from "@/sdk";

import { getMappedIntent } from "./getMappedIntent";

export function useIVRInfo() {
    const task = useMostRecentTask();
    const voiceTask = isVoiceTask(task) ? task : null;
    const partner = usePartner();
    return getIVRInfo(partner, voiceTask);
}

function getIVRInfoFromCSD() {
    const {
        INTENT: intent,
        SUMMARY: summary,
        CONVERSATIONAL_SUMMARY: conversationalSummary,
        CUSTOMER_NAME: customerName,
        ORDER_NUMBER: orderNumber,
        PRODUCT_LINK: productLink,
    } = useCallDetailsStore.getState().callDetails;

    return {
        intent,
        summary,
        customerName,
        orderNumber,
        productLink,
        conversationalSummary,
    } as IVRInfo;
}

export function getIVRInfo(partner: Partner, voiceTask: VoiceTask | null) {
    const {
        intent: intentFromVoiceTask,
        summary: summaryFromVoiceTask,
        customerName: customerNameFromVoiceTask,
        orderNumber: orderNumberFromVoiceTask,
        productLink: productLinkFromVoiceTask,
        conversationalSummary: conversationalSummaryFromVoiceTask,
    } = voiceTask?.ivrInfo || {};

    const {
        intent: intentFromCSD,
        summary: summaryFromCSD,
        customerName: customerNameFromCSD,
        orderNumber: orderNumberFromCSD,
        productLink: productLinkFromCSD,
        conversationalSummary: conversationalSummaryFromCSD,
    } = getIVRInfoFromCSD();

    const intent = intentFromVoiceTask ? getMappedIntent(intentFromVoiceTask, partner) : intentFromCSD;
    const summary = summaryFromVoiceTask ?? summaryFromCSD;
    const conversationalSummary = conversationalSummaryFromVoiceTask ?? conversationalSummaryFromCSD;
    const customerName = customerNameFromVoiceTask ?? customerNameFromCSD;
    const orderNumber = orderNumberFromVoiceTask ?? orderNumberFromCSD;
    const productLink = productLinkFromVoiceTask ?? productLinkFromCSD;

    return { ...voiceTask?.ivrInfo, intent, summary, customerName, orderNumber, productLink, conversationalSummary };
}
